import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CollapsibleCard } from "~/components/CollapsibleCard";
export const CollapsibleSection = /*#__PURE__*/ memo((param)=>{
    let { title, children, onOpenChange, isExpanded, "data-testid": testId } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "border-b border-grey-3 last:border-b-0",
        "data-testid": testId,
        children: /*#__PURE__*/ _jsx(CollapsibleCard, {
            header: /*#__PURE__*/ _jsx("div", {
                className: "text-10 font-bold uppercase",
                children: title
            }),
            variant: "ghost",
            onOpenChange: onOpenChange,
            isDefaultExpanded: isExpanded,
            children: children
        })
    });
});
CollapsibleSection.displayName = "CollapsibleSection";
